'use client';

import type { ImageModel } from '@coas/db/model';
import Image from 'next/image';
import Link from 'next/link';
import { imgLoader } from '~/shared/lib';

type BannerProps = {
    banner?: ImageModel | null;
    bannerLink?: string | null;
};

export const Banner = ({ banner, bannerLink }: BannerProps) => {
    if (banner === null || !banner?.key) return null;

    return (
        <>
            <Link
                key={banner.key}
                href={bannerLink ?? '/'}
                className={'relative box-content w-full border-b-neutral-50'}
                style={{ minHeight: 'min(max(8rem, 10vw), 12svh)' }}
            >
                <Image
                    key={banner.key}
                    loader={imgLoader({ src: banner.key, width: banner.width, quality: 75 })}
                    src={banner.key}
                    placeholder={'blur'}
                    blurDataURL={banner.lqip ?? undefined}
                    className={'z-50 h-full cursor-default object-cover md:cursor-pointer'}
                    fill
                    sizes={'(max-width: 768px) 768px, (max-width: 1024px) 1024px, (max-width: 1536px) 1536px, 2048px'}
                    alt={''}
                />
            </Link>
        </>
    );
};
